import { createFileRoute } from "@tanstack/react-router";
import { FollowupSettingsPage } from "@/features/ai/followup-settings-page";

export const Route = createFileRoute("/_authenticated/ai/followups/")({
  head: () => ({ meta: [{ title: "Follow-ups · Rogue Admin" }] }),
  component: FollowupSettingsPage,
});
